import { Component, OnInit } from '@angular/core';
import {MatMenuModule} from '@angular/material/menu';
import { BlogService } from '../services/blog.service';
import { Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-blog-category',
  templateUrl: './blog-category.component.html',
  styleUrls: ['./blog-category.component.scss']
})
export class BlogCategoryComponent implements OnInit {
  
ides:any;
categories:any[]= [];
  @Output() newItemEvent = new EventEmitter<string>();
  constructor(
    private BlogService:BlogService
  ) {
    this.BlogService.getCateg().then((res:any)=>{
      console.log(res,'resp')
      res?.map((item:any)=>{
        if(item.title === 'NFT / Blockchain Development'){
        item.title=item.title.replace(' / ','-')
        this.categories.push(item)
        console.log(this.categories,'this.categories')
        }
        else{
          this.categories.push(item)
        }
      })
      //this.categories = res;
     
      
    })
 
   }

  ngOnInit(): void {
  
  }
  filter(data:any){
this.newItemEvent.emit(data)
    // this.newItemEvent.emit(data);  
   // console.log(this.ides,'ides') 
  }
  
  
}